var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{staticStyle:{"height":"200px"}},[_c('el-tab-pane',{attrs:{"label":"资源审核"}},[_c('resources-examine')],1),_c('el-tab-pane',{attrs:{"label":"资源录入"}},[_c('resources-input')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }